
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone-dob",
      function () {
        return require("private-next-pages/phone-dob/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone-dob"])
      });
    }
  